import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { createVideoGroup } from "../store/action";
import { connect, useSelector } from "react-redux";
import { GroupForm } from "modules/video/components/CreateFolderForm";
import { ApiError } from "components";
import { GroupError, GroupInput } from "../store/actionType";

interface CreateGroupProps {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & CreateGroupProps;

const CreateGroup: React.FC<Props> = ({ closeModal, onCreatehVideoGroup }) => {
  const [formData, setFormData] = useState<GroupInput>({
    name: "",
    description: "",
    group_order: 0,
    imageFile: undefined,
    image: "",
    icon: "",
    button_name:"",
    eligibility:""
  });
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<GroupError>({});
  const [apiError, setApiError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const groupsState = useSelector(
    (state: any) => state.videoGroups.videoGroupsState
  );
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? Number(value) : value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    if (formData.name.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,
        name: "Group name is required",
      }));
    }
    if (formData.description.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,
        description: "Group description is required",
      }));
    }
    if (formData.group_order === 0) {
      setError((prevErrors) => ({
        ...prevErrors,
        group_order: "Group group order is required",
      }));
    }
    let uploadedFilename: string | undefined = undefined;
    if (imageFile) {
      const uploadUrl = `${process.env.REACT_APP_IMAGE_UPLOAD_BASE_URL}`;
      const form = new FormData();
      form.append("file", imageFile);
      const response = await fetch(uploadUrl ?? "", {
        method: "POST",
        body: form,
      });
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Upload failed:", errorText);
        throw new Error("Failed to upload image");
      }

      const result = await response.json();
      uploadedFilename = result?.imageURL;

      if (!uploadedFilename) {
        console.error("Image upload response invalid", result);
        throw new Error("Image upload response invalid");
      }
    }
    if (formData.name.trim() !== "" && formData.description.trim() !== "") {
      const input: GroupInput = {
        name: formData.name.trim(),
        description: formData.description.trim(),
        group_order: formData.group_order,
        button_name:formData.button_name?.trim(),
        eligibility:formData.eligibility?.trim()
      };

      if (formData.icon) {
        input.icon = formData.icon.trim();
      }

      if (uploadedFilename) {
        input.image = uploadedFilename;
      }
      setLoading(true);
      onCreatehVideoGroup(input);
      setSubmitted(true);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!groupsState.isLoading && submitted) {
      if (groupsState.error) {
        setApiError(groupsState.error); // show error
      } else {
        setApiError(null);
        closeModal(false);
      }
    }
  }, [groupsState.isLoading, groupsState.error, submitted, closeModal]);
  return (
    <>
      <GroupForm
        header="Create Group"
        formData={formData}
        error={error}
        handleChange={handleChange}
        handleSubmit={handleSave}
        loading={loading}
        handleImageFileChange={setImageFile}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onCreatehVideoGroup: (input: GroupInput) => dispatch(createVideoGroup(input)),
});

export default connect(null, mapDispatchToProps)(CreateGroup);
